export default "__VITE_ASSET__CY$GsIE5__"